import React from 'react'

// Main Chakra UI components:
import { Box, Center, HStack as ChakraHStack, Image, Text, VStack } from '@chakra-ui/react'

// Icons:
import 'remixicon/fonts/remixicon.css'

// Local components and data:
import useMatchMedia from './MatchMedia'

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const actionColors = {
    full: '#dd0000',
    partial: '#cc4400',
    move: '#eecc00',
    free: '#02cc02',
}

export const cursorColors = {
    green: '#02cc02',
    yellow: '#eecc00',
    red: '#dd0000',
    gray: '#666666',
}

export const mapColors = {
    green: '#02cc02',
    yellow: '#eecc00',
    red: '#dd0000',
    gray: '#666666',
    purple: '#9900cc',
    brown: '#885500',
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const NotePane = ({ children, style }) => {
    const isDesktop = useMatchMedia('(min-width:992px)', true)
    return (
        <Box bg={'#222222'} style={{
            borderRadius: isDesktop ? 20 : 12,
            padding: isDesktop ? 30 : 16,
            margin: isDesktop ? 20 : 8,
            ...style,
            fontWeight: 550
        }}>
            {children}
        </Box>
    )
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const SectionHeader = ({ children, id }) => (
    <Center h={'75px'} id={id}>
        <Text fontSize={'5xl'}>
            <u>{children}</u>
        </Text>
    </Center>
)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const SubsectionHeader = ({ children, id }) => (
    <Text fontSize={'2xl'} style={{ width: '100%' }} id={id}>
        <b>{children}</b>
    </Text>
)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const RadialImage = ({ src, alt, style }) => {
    const isDesktop = useMatchMedia('(min-width:992px)', true)
    const size = isDesktop ? '400px' : '280px'
    return (
        <div
            style={{
                backgroundImage: `radial-gradient(circle at center, #00000000, #0f0f0fff 75%, #0f0f0fff), url("/playersguide/${src}")`,
                width: size,
                height: size,
                maxWidth: '90vw',
                maxHeight: '90vw',
                backgroundSize: 'cover',
                margin: isDesktop ? 20 : 10,
                ...(style || {}),
            }}
        />
    )
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const RectImage = ({ src, alt, style, heading, maxWidth }) => (
    <div style={{ padding: 20, maxWidth: maxWidth, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Image
            src={src}
            alt={alt}
            style={{
                borderRadius: 20,
                ...(style || {}),
            }}
        />
        {heading && (
            <Text fontSize={'sm'} mt={3}>
                <i>{heading}</i>
            </Text>
        )}
    </div>
)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const ActionBar = ({ pattern }) => (
    <div style={{ width: '100%' }}>
        {pattern.map((row, rowIndex) => (
            <Box key={rowIndex} width={'100%'} height={'20px'} p={5}>
                <ChakraHStack>
                    {' '}
                    {row.map((p, colIndex) => (
                        <Box
                            key={`${rowIndex}-${colIndex}`}
                            style={{ height: '10px', width: p.width, backgroundColor: actionColors[p.type] }}
                        />
                    ))}
                </ChakraHStack>
            </Box>
        ))}
    </div>
)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const HStack = ({ children, spacing, style, inline }) => {
    const isPhoneResolution = useMatchMedia('(max-width:600px) or (max-height:600px)', true)
    if (isPhoneResolution && !inline) {
        return (
            <VStack spacing={spacing} align="center" style={{ ...(style || {}), width: '100%' }}>
                {children}
            </VStack>
        )
    }
    else {
        return (
            <ChakraHStack spacing={spacing} style={{ ...(style || {}), width: '100%' }}>
                {children}
            </ChakraHStack>
        )
    }
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const style = {
    sectionSpacing: '250px',
    defaultSpacing: '50px',
    defaultImageWidth: '640px',
    maxBodyWidth: '1024px',
    defaultColumnWidth: '60%',
}
